import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import CyberpunkHero3D from '../../components/3D/CyberpunkHero3D'
import SimplePerformanceMonitor from '../../components/3D/SimplePerformanceMonitor'
import CyberpunkHeader from '../../components/Header/CyberpunkHeader'
import CyberpunkHeaderLinks from '../../components/CyberpunkHeaderLinks'
import HeaderNavLinks from '../../components/HeaderNavLinks'

const useStyles = makeStyles({
  root: {
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  performanceToggle: {
    position: 'absolute',
    top: '120px', // Below cyber home header
    left: '20px',
    zIndex: 9999,
    fontFamily: '"Share Tech Mono", monospace',
    fontSize: '0.8rem',
    color: '#00ffff',
    cursor: 'pointer',
    padding: '8px 12px',
    border: '1px solid #ff00ff',
    background: 'rgba(12, 12, 12, 0.95)',
    borderRadius: '4px',
    backdropFilter: 'blur(10px)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'rgba(255, 0, 255, 0.1)',
      boxShadow: '0 0 15px rgba(255, 0, 255, 0.3)',
      transform: 'translateY(-1px)',
    },
  },
  performancePanel: {
    position: 'absolute',
    top: '170px',
    left: '20px',
    zIndex: 9998,
    background: 'rgba(10, 10, 10, 0.95)',
    border: '1px solid #00ffff',
    borderRadius: '4px',
    padding: '10px',
    backdropFilter: 'blur(15px)',
    boxShadow: '0 0 20px rgba(0, 255, 255, 0.2)',
  },
  statusIndicator: {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    marginRight: '8px',
    backgroundColor: '#00ff00',
    boxShadow: '0 0 5px rgba(0, 255, 0, 0.5)',
    animation: '$pulse 2s infinite',
  },
  '@keyframes pulse': {
    '0%': {
      backgroundColor: '#00ff00',
      boxShadow: '0 0 5px rgba(0, 255, 0, 0.5)',
    },
    '50%': {
      backgroundColor: '#00ffff',
      boxShadow: '0 0 10px rgba(0, 255, 255, 0.8)',
    },
    '100%': {
      backgroundColor: '#00ff00',
      boxShadow: '0 0 5px rgba(0, 255, 0, 0.5)',
    },
  },
})

const CyberSpacePage = () => {
  const classes = useStyles()
  const [showPerformance, setShowPerformance] = useState(false)

  return (
    <div className={classes.root}>
      {/* Navigation Header */}
      <CyberpunkHeader
        color="transparent"
        brand="[CYBERSPACE]"
        rightLinks={<CyberpunkHeaderLinks/>}
        leftLinks={<HeaderNavLinks/>}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: 'dark'
        }}
      />

      {/* 3D Cyberspace Scene */}
      <CyberpunkHero3D/>

      {/* Performance Monitor Overlay - Top Right */}
      <Box
        className={classes.performanceToggle}
        onClick={() => setShowPerformance(!showPerformance)}
      >
        <span className={classes.statusIndicator}></span>
        <Typography component="span" style={{ fontSize: 'inherit', color: 'inherit' }}>
          {showPerformance ? '[HIDE_DIAGNOSTICS]' : '[SYSTEM_DIAGNOSTICS]'}
        </Typography>
      </Box>

      {/* Performance Panel */}
      {showPerformance && (
        <Box className={classes.performancePanel}>
          <SimplePerformanceMonitor/>
        </Box>
      )}

      {/* Beta Warning Label */}
      <Box
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          zIndex: 10000,
          fontFamily: '"Share Tech Mono", monospace',
          fontSize: '0.9rem',
          color: '#ff0080',
          padding: '12px 16px',
          border: '2px solid #ff0080',
          background: 'rgba(0, 0, 0, 0.9)',
          borderRadius: '4px',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 0 20px rgba(255, 0, 128, 0.5)',
          textShadow: '0 0 10px rgba(255, 0, 128, 0.8)',
        }}
      >
        <Typography component="span" style={{ fontSize: 'inherit', color: 'inherit', fontWeight: 'bold' }}>
          ⚠ [BETA_VERSION] - CYBERSPACE_UNDER_CONSTRUCTION
        </Typography>
      </Box>
    </div>
  )
}

export default CyberSpacePage
